<template>
  <div class="navbar-user">
    <div class="container" v-if="company">
      <div class="navbar-user__name">
        <p>{{ user.username }}</p>
      </div>
      <p class="text-center"><a @click="logout">Kirjaudu ulos</a></p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["user", "company"]),
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: "Login" });
        });
    },
  },
};
</script>
